import React, { useMemo } from 'react';
import useStats from '../hooks/useStats';
import StatsTable from './common/StatsTable';
import TIME_PERIODS from './constants/periods';

const RESOURCES = [
  '/v1/statistics/sms_messages',
  '/v1/statistics/mms_messages',
];

const INITIAL_STATE = {
  sms_messages: {},
  mms_messages: {},
};

const SmsStats = () => {
  const { data, loading } = useStats({
    resources:    RESOURCES,
    initialState: INITIAL_STATE,
  });

  const { sms_messages: smsStats, mms_messages: mmsStats } = data;

  const columns = useMemo(() => [
    { header: 'Text Messages Sent & Received', id: 'messages', rowSpan: 2 },
    { header: 'Messages', id: 'message-types', colSpan: 2 },
    { header: 'Segments', id: 'segment-types', colSpan: 2 },
  ], []);

  const subColumns = useMemo(() => [
    { header: 'SMS', id: 'sms-messages', className: 'text-center' },
    { header: 'MMS', id: 'mms-messages', className: 'text-center' },
    { header: 'SMS', id: 'sms-segments', className: 'text-center' },
    { header: 'MMS', id: 'mms-segments', className: 'text-center' },
  ], []);

  const rows = useMemo(() => [
    {
      period: TIME_PERIODS.TODAY,
      values: [
        { id: 'sms-today', value: smsStats.smsMessagesToday },
        { id: 'mms-today', value: mmsStats.mmsMessagesToday },
        { id: 'sms-segments-today', value: smsStats.smsSegmentsToday },
        { id: 'mms-segments-today', value: mmsStats.mmsSegmentsToday },
      ],
    },
    {
      period: TIME_PERIODS.THIS_WEEK,
      values: [
        { id: 'sms-week', value: smsStats.smsMessagesThisWeek },
        { id: 'mms-week', value: mmsStats.mmsMessagesThisWeek },
        { id: 'sms-segments-week', value: smsStats.smsSegmentsThisWeek },
        { id: 'mms-segments-week', value: mmsStats.mmsSegmentsThisWeek },
      ],
    },
    {
      period: TIME_PERIODS.THIS_MONTH,
      values: [
        { id: 'sms-month', value: smsStats.smsMessagesThisMonth },
        { id: 'mms-month', value: mmsStats.mmsMessagesThisMonth },
        { id: 'sms-segments-month', value: smsStats.smsSegmentsThisMonth },
        { id: 'mms-segments-month', value: mmsStats.mmsSegmentsThisMonth },
      ],
    },
    {
      period: TIME_PERIODS.LAST_MONTH,
      values: [
        { id: 'sms-last-month', value: smsStats.smsMessagesLastMonth },
        { id: 'mms-last-month', value: mmsStats.mmsMessagesLastMonth },
        { id: 'sms-segments-last-month', value: smsStats.smsSegmentsLastMonth },
        { id: 'mms-segments-last-month', value: mmsStats.mmsSegmentsLastMonth },
      ],
    },
  ], [smsStats, mmsStats]);

  return (
    <StatsTable
      title="Text Messages Sent & Received"
      columns={columns}
      subColumns={subColumns}
      rows={rows}
      loading={loading}
    />
  );
};

export default React.memo(SmsStats);
